import { render } from 'preact';
import { ConnectPage } from './ConnectPage';
import { OAuthCallbackPage } from './OAuthCallbackPage';
import './styles.css';

function App() {
  const path = window.location.pathname.replace(/\/$/, '');

  if (path === '/connect/oauth/callback') {
    return <OAuthCallbackPage />;
  }

  return <ConnectPage />;
}

render(<App />, document.getElementById('root')!);
